module.exports = __webpack_public_path__ + "img/australia.fa36fc7e.png";